import { actions } from "./notification.actions";
import { selectors } from "./notification.selectors";

export const notification = {
  actions: actions,
  selectors: selectors,
};
